<template>
	<!-- 	<a-select show-search 
			v-model='values'
			:placeholder="placeholder"
			:style="styles"
			:default-active-first-option="false"
			:show-arrow="false"
			:filter-option="false"
			:not-found-content="null"
			@search="handleSearch"
			@blur="handleBlur" 
			@change="handleChange">
		
		<a-select-option v-for='(item,ind) in tabData' :value="item" :key='ind'>{{item}}</a-select-option>
	</a-select> -->
		<a-auto-complete :data-source="tabData" :style="styles" :placeholder="placeholder" @change="handleChange"
			@focus='focus' v-model="values" @search="handleSearch" >
			<template slot="dataSource">
			     <a-select-option v-for='(item , ind) in tabData' :value="item.iposelling_id+''" :key='ind + "4902"'>
					 {{item.companyname}}
				 </a-select-option>
			</template>
		</a-auto-complete>
		
</template>

<script>
	import App from '@/assets/app.js';
	export default {
		model: {
			prop: 'value',
			event: 'child'
		},
		props: {
			styles: { //样式
				default: 'width: 200px',
			},
			url: { //请求url
				default: '',
			},
			// keyid: {
			// 	default:'',
			// },
			// keyname: {
			// 	default:'',
			// },
			onhand: { //点击方式
				default: 'click',
			},
			val: { //回显
				default: '',
			},
			valonce: { //回显
				default: '',
			},
			params: {
				default: {
					type: 'industrys'
				},
			},
			placeholder: {
				default: '',
			},
			zz: {
				default: '',
			},
			openfirst: {
				default: false,
			},
		},
		data() {
			return {
				//下啦列表
				tabData: [],
				//input
				values: '',
				//接口参数
				tableparams: {}
			}
		},
		watch: {
			val: {
				immediate: true,
				handler(ev) {
					if (ev) {
						setTimeout(()=>{
						this.handleChange(ev)
						},100)
					}
				}
			},
			values: {
				deep:true,
				immediate: true,
				handler(ev) {
					if(this.zz == 'zz'){
						this.values = this.values.replace(/[,]+/g, '')
					}
				}
			},
			onclick:{
				deep:true,
				immediate: true,
				handler(ev) {
					// this.handleChange(this.val)
				}
			}
		},
		mounted() {
			for (let key in this.params) {
				this.tableparams[key] = this.params[key]
			}
			// this.getdata()
			setTimeout(()=>{
				this.handleChange(this.valonce)
			},500)
		},
		methods: {
			getdata(val) {
				this.tableparams['searchstr'] = val||''
				this.$ajax({
					method: 'post',
					url: this.url,
					headers: {
						token: this.$store.state.token
					},
					data: this.tableparams
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.tabData = res.data.result
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			focus(){
				this.getdata()
			},
			handleSearch(val) {
				console.log(val.companyname)
				this.values = val
				this.tabData = []
				if(val){
					this.getdata(val)
				}
			},
			handleBlur(val) {
				console.log('handleBlur',val)
				// this.$emit('child', this.values)
			},
			handleChange(value) {
				let _this = this
				_this.tabData = !value || value.indexOf('@') >= 0 ?
					[] :
					_this.tabData;

				_this.values = value
				_this.$emit('child', _this.values)
			},
		}
	}
</script>

<style lang='scss'>
		.ant-select-dropdown-menu-item{
			font-size: .75rem !important;
		}
</style>
